import React, { useRef, useState, useEffect, useCallback } from "react";
import { Row, Col, Container, Button, Spinner } from 'react-bootstrap';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import copy from "copy-to-clipboard";
import BottomNavBar from "../components/BottomNavBar";
import BlockHeading from "../components/BlockHeading";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Captcha from "../components/Captcha";
import StudentReviewDetails from "../components/StudentReviewDetails";
import StepAway from "../components/StepAway";
import * as studentDetailsAPI from "../services/studentEntries";
import * as emailSendAPI from "../services/email";
import * as fileUploadApi from "../services/fileUpload";
import toast, { toastConfig } from 'react-simple-toasts';

const Review = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();

    const LORInput = useRef();
    const proofOfEnrollInput = useRef();
    const taxReturnInput = useRef();
    const essayInput = useRef();
 
    const [lorFile, setLorFile] = useState([]);
    const [lorFileErrMsg, setLorFileErrMsg] = useState(false);
    const [proofOfEnrollFile, setProofOfEnrollFile] = useState([]);
    const [proofOfEnrollFileErrMsg, setProofOfEnrollFileErrMsg] = useState(false);
    const [taxReturnFile, setTaxReturnFile] = useState([]);
    const [taxReturnFileErrMsg, setTaxReturnFileErrMsg] = useState(false);
    const [essayFile, setEssayFile] = useState([]);
    const [essayFileErrMsg, setEssayFileErrMsg] = useState(false);
    const [studHCode, setHexCode] = useState('');
    const [details, setDetails] = useState({});
    const [captchaValue, setCaptchaValue] = useState("");
    const [captchaError, setCaptchaError] = useState(false);
    const [copyUrl, setCopyUrl] = useState('');
    const [loader, setLoader] = useState(false)

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    
    useEffect(() => {
        document.title = 'Review | Families of WWII Veterans';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []);
    useEffect(() => {
        let hexCode =location?.state?.hexCode ? location.state.hexCode : "";
        if(hexCode === ""){
            hexCode = searchParams.get("code");
        }
        setHexCode(hexCode);
        let modifiedURL = window.location.href.search("code")
        let url = ""
        if (modifiedURL > -1) {
            url = `${window.location.href}`
        } else {
            url = `${window.location.href}?code=${hexCode}`
        }
        setCopyUrl(url)
    }, [location?.state?.hexCode,searchParams]);
    

    const getReviewDetails = useCallback(async () => {
        setLoader(true)
        try {
            await studentDetailsAPI.getStudentEntriesDetails(`${studHCode}/student-entries`).then((res) => {
               
                setLoader(false)
                if (res.status === 200) {
                    setDetails(res.data[0]);
                } else {
                    if(res.status === 204){
                        return 
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    },[studHCode])

    useEffect(() => {
        if(studHCode){
            getReviewDetails()
        }
    }, [studHCode,getReviewDetails]);

    const { handleSubmit } = useForm({ defaultValues: {} });
    const onSubmit = async () => {
        if (!captchaValue) {
            setCaptchaError(true)
            return
        } else {
            setCaptchaError(false)
        }
        if ((lorFile && lorFile.length <= 0)
            || (proofOfEnrollFile && proofOfEnrollFile.length <= 0)
            || (taxReturnFile && taxReturnFile.length <= 0)
            || (essayFile && essayFile.length <= 0)) {
            if (lorFile && lorFile.length <= 0) {
                setLorFileErrMsg(true)
            } if (proofOfEnrollFile && proofOfEnrollFile.length <= 0) {
                setProofOfEnrollFileErrMsg(true)
            } if (taxReturnFile && taxReturnFile.length <= 0) {
                setTaxReturnFileErrMsg(true)
            } if (essayFile && essayFile.length <= 0) {
                setEssayFileErrMsg(true)
            }
            return
        }
        else {
            setLorFileErrMsg(false)
            setProofOfEnrollFileErrMsg(false)
            setTaxReturnFileErrMsg(false)
            setEssayFileErrMsg(false)

        }

        let listOFFiles = [lorFile[0], proofOfEnrollFile[0], taxReturnFile[0], essayFile[0]];
        let listFileNames = ["LORFile", "PORFile", "TRFile", "ESFile"];
        const fd = new FormData();
        Array.from(listOFFiles).forEach((file, ind) => {
            fd.append(listFileNames[ind], file);
        });

        const appBaseUrl = `${window.location.origin}${process.env.PUBLIC_URL || ''}`.replace(/\/$/, '');
        let InfoObj = {
            firstName: details.firstName,
            lastName: details.lastName,
            WebSite: `${appBaseUrl}/counselor?code=${studHCode}`,
            toEmail: details.emailAddress,
            type: "Student"
        }
        setLoader(true) 
        try {
            await fileUploadApi.postDocuments(fd,`files?studentCode=${studHCode}`).then(async(res) => {
                setLoader(false)
                if (res) {
                    setLoader(true)
                    try {
                        await emailSendAPI.postEmailSend(InfoObj, "send-email").then((res) => {
                            setLoader(false)
                            if (res.status === 200) {
                                navigate("/student/thank-you/",{
                                    state:{hexCode : studHCode}
                                });     
                            } else if (res.status === 422) {
                                let errorData = res?.data?.errors
                                if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                                    Object.keys(errorData).forEach((err, index) => {
                                        toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                                    })
                                }
                            } else {
                                toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                            }
                        })
                        .catch(function (error) {
                            setLoader(false)
                            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                            return error
                        });
                    }
                    catch (error) {
                        setLoader(false)
                        toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                        return error
                    }    
                }
            })
        }
        catch (error) {
            setLoader(false)
        }    
    }

    const handleTaxReturnUpload = () => {
        taxReturnInput.current.click()
    }
    const handleEssayUpload = () => {
        essayInput.current.click()
    }
    const handleLORFileUpload = () => {
        LORInput.current.click()
    }
    const handleProofOfEnrollUpload = () => {
        proofOfEnrollInput.current.click()
    }

    const handleSelectedFiles = (e, name) => {
        let uploadedfiles = e.target.files ? e.target.files : []

        switch (name) {
            case "LOR":
                let LORfile = uploadedfiles

                setLorFile(LORfile);
                setLorFileErrMsg(false)
                break;
            case "POE":
                let POEfiles = uploadedfiles

                setProofOfEnrollFile(POEfiles)
                setProofOfEnrollFileErrMsg(false)
                break;
            case "TR":
                let TRfiles = uploadedfiles

                setTaxReturnFile(TRfiles)
                setTaxReturnFileErrMsg(false)
                break;
            case "ES":
                let ESFile = uploadedfiles

                setEssayFile(ESFile)
                setEssayFileErrMsg(false)
                break;
            default:
        }

    }
    const handleFileUploadDelete = (name) => {
        switch (name) {
            case "LOR":
                setLorFile([]);

                setLorFileErrMsg(true)
                break;
            case "POE":
                setProofOfEnrollFile([])

                setProofOfEnrollFileErrMsg(true)
                break;
            case "TR":
                setTaxReturnFile([])

                setTaxReturnFileErrMsg(true)
                break;
            case "ES":
                setEssayFile([])

                setEssayFileErrMsg(true)
                break;
            default:
        } 
    }
    const handleBack = () => {
        navigate("/work-activities",{
            state:{hexCode : studHCode}
        })
    }
    const onCaptchaChange = (value) => {
        setCaptchaValue(value)
    }
    const handleCopy = () => {
        copy(copyUrl);
        alert(`URLGOESHERE copied to your clipboard. Save this URL.`);
    }
    const handleNavBack = (to) => {
        navigate(to,{
            state:{hexCode : studHCode}
        })
    }

    return (
        <>
            <Header title="Scholarship Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <StepAway handleCopy={handleCopy} copyInputValue={copyUrl} />
                        <Nav navbType="student" handleNavBack={handleNavBack}/>
                        {Object.keys(details).length !== 0 &&
                            <StudentReviewDetails details={details} />
                        }
                        <BlockHeading title={`Upload the following documents to this application below:`} />
                        <p><strong>Accepted file formats:</strong> PDF, Microsoft Word, JPEG, JPG &amp; PNG.</p>
                        <Row>
                            <Col lg={6} md={6} sm={12}>
                                <div style={{ marginTop: 10, marginBottom: 10 }}>
                                    <Col md={12} className="pl-0" >
                                        <label>Letter of recommendation:<strong className="text-primary">*</strong></label>
                                        <button className="fileUploadButton" onClick={handleLORFileUpload}>
                                            Choose Files ...
                                            <div className="fileUploadBrowse">Browse</div>
                                        </button>
                                        <input type="file" ref={LORInput} style={{ display: "none" }}
                                            onChange={(e) => handleSelectedFiles(e, "LOR")}
                                            onClick={(e)=> {
                                                e.target.value = null
                                           }}
                                            accept=".png,.jpg,.jpeg,.doc,.docx,.pdf" />
                                        {
                                            lorFileErrMsg ?
                                                <small className="text-primary">
                                                    Letter of recommendation is required!
                                                </small> : null
                                        }

                                    </Col>
                                    {lorFile && Object.keys(lorFile).map((fileno, ind) => {
                                        return (
                                            <div className="filesUploadedList" key={ind}>
                                                <p key={ind} className="mb-0">{lorFile[fileno].name}</p>
                                                <Button variant="light" className="ml-2 fileUploadDeleteButton"
                                                    onClick={() => handleFileUploadDelete("LOR")}>×</Button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={12}>
                                <div style={{ marginTop: 10, marginBottom: 10 }}>
                                    <Col md={12} className="pl-0">
                                        <label>Transcript or proof of enrollment:<strong className="text-primary">*</strong></label>
                                        <button className="fileUploadButton" onClick={handleProofOfEnrollUpload}>
                                            Choose Files ...
                                            <div className="fileUploadBrowse">Browse</div>
                                        </button>
                                        <input type="file" ref={proofOfEnrollInput} style={{ display: "none" }}
                                            onChange={(e) => handleSelectedFiles(e, "POE")}
                                            onClick={(e)=> {
                                                e.target.value = null
                                           }}
                                            accept=".png,.jpg,.jpeg,.doc,.docx,.pdf" />
                                        {
                                            proofOfEnrollFileErrMsg ?
                                                <small className="text-primary">
                                                    Transcript or proof of enrollment is required!
                                                </small> : null
                                        }
                                    </Col>
                                    {proofOfEnrollFile && Object.keys(proofOfEnrollFile).map((fileno, ind) => {
                                        return (
                                            <div className="filesUploadedList" key={ind}>
                                                <p key={ind} className="mb-0">{proofOfEnrollFile[fileno].name}</p>
                                                <Button variant="light" className="ml-2 fileUploadDeleteButton"
                                                    onClick={() => handleFileUploadDelete("POE")}>×</Button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={12}>
                                <div style={{ marginTop: 10, marginBottom: 10 }}>
                                    <label>W2 form or previous year's household tax return:<strong className="text-primary">*</strong></label>
                                    <Col md={12} className="pl-0">
                                        <button className="fileUploadButton" onClick={handleTaxReturnUpload}>
                                            Choose Files ...
                                            <div className="fileUploadBrowse">Browse</div>
                                        </button>
                                        <input type="file" ref={taxReturnInput} style={{ display: "none" }}
                                            onChange={(e) => handleSelectedFiles(e, "TR")}
                                            onClick={(e)=> {
                                                e.target.value = null
                                           }}
                                            accept=".png,.jpg,.jpeg,.doc,.docx,.pdf" />
                                        {
                                            taxReturnFileErrMsg ?
                                                <small className="text-primary">
                                                    W2 form or previous year's household tax return is required!
                                                </small>
                                                : null
                                        }
                                    </Col>
                                    {taxReturnFile && Object.keys(taxReturnFile).map((fileno, ind) => {
                                        return (
                                            <div className="filesUploadedList" key={ind}>
                                                <p key={ind} className="mb-0">{taxReturnFile[fileno].name}</p>
                                                <Button variant="light" className="ml-2 fileUploadDeleteButton"
                                                    onClick={() => handleFileUploadDelete("TR")}>×</Button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={12}>
                                <div style={{ marginTop: 10, marginBottom: 10 }}>
                                    <label>500 word essay on how WWII affected your life:<strong
                                        className="text-primary">*</strong></label>
                                    <Col md={12} className="pl-0">
                                        <button className="fileUploadButton" onClick={handleEssayUpload}>
                                            Choose Files ...
                                            <div className="fileUploadBrowse">Browse</div>
                                        </button>
                                        <input type="file" ref={essayInput} style={{ display: "none" }}
                                            onChange={(e) => handleSelectedFiles(e, "ES")}
                                            onClick={(e)=> {
                                                e.target.value = null
                                           }}
                                            accept=".png,.jpg,.jpeg,.doc,.docx,.pdf" />
                                        {
                                            essayFileErrMsg ?
                                                <small className="text-primary">
                                                    500 word essay on how WWII affected your life is required!
                                                </small>
                                                : null
                                        }
                                    </Col>
                                    {essayFile && Object.keys(essayFile).map((fileno, ind) => {
                                        return (
                                            <div className="filesUploadedList" key={ind}>
                                                <p key={ind} className="mb-0">{essayFile[fileno].name}</p>
                                                <Button variant="light" className="ml-2 fileUploadDeleteButton"
                                                    onClick={() => handleFileUploadDelete("ES")}>×</Button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Col>
                        </Row>

                        <hr />
                        <Captcha onCaptchaChange={onCaptchaChange} captchaError={captchaError} />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <BottomNavBar handleBack={handleBack} submitButtonTitle="SUBMIT"
                            />
                        </form>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default Review